import React from 'react';
import { shape } from 'prop-types';
import styled, { css } from 'styled-components';
import { ReactComponent as ArrowUpSvg } from '../../../assets/icons/angle-up.svg';
import { ReactComponent as ArrowDownSvg } from '../../../assets/icons/angle-down.svg';

const IconStyle = css`
  width: 12px;
  height: auto;
  cursor: pointer;
`;

const DownIcon = styled(ArrowDownSvg)`
  ${IconStyle};
`;

const UpIcon = styled(ArrowUpSvg)`
  ${IconStyle};
`;

function RowExpandButton ({ row }) {

  return (
    // eslint-disable-next-line
    <span {...row.getToggleRowExpandedProps()} onClick={e => {e.stopPropagation(); row.toggleRowExpanded()}}>
      {row.isExpanded ? <UpIcon /> : <DownIcon />}
    </span>
  );
}

RowExpandButton.propTypes = {
  row: shape({}).isRequired,
};

export default RowExpandButton;
